import { Divider as MuiDivider } from '@mui/material';

export const Divider = MuiDivider;
